import CardMensagemHistory from './CardMensagemHistory'

export default CardMensagemHistory